(function () {
	'use strict';

	a3_cabin_reports.factory('CustomerEventFactory', CustomerEventFactory);
	/**
	* @memberof CabinReports
	* @ngdoc factory
	* @name CustomerEventFactory
	* @description 
	*   Add, Update, Delete and Get Passenger Incidents
	* @ngInject
	*/
	function CustomerEventFactory(GenericService) {

		var objType = 'CustomerEvents';
		var objCallback = CustomerEvent;

		/**
		 * Initialize the Passenger Incident
		 * @memberof CustomerEventFactory
		 */
		function CustomerEvent() {
			this.GetId = GetId;
			this.Synced = false;
		}

		var service = {
			getCustomerEventsFromStorage: getCustomerEventsFromStorage,
			setCustomerEventToStorage: setCustomerEventToStorage,
			setCustomerEventsToStorage: setCustomerEventsToStorage,
			getCustomerEventsByFlightId: getCustomerEventsByFlightId,
			groupFlightCustomerEventsByPassenger: groupFlightCustomerEventsByPassenger,
			getFlightCustomerEvents: getFlightCustomerEvents,
			updateCustomerEvent: updateCustomerEvent,
			saveCustomerEvent: saveCustomerEvent,
			removeCustomerEvent: removeCustomerEvent,
			getUnsyncedCustomerEvents: getUnsyncedCustomerEvents,
			deleteOldCustomerEvents: deleteOldCustomerEvents

		};

		function GetId() {
			return this.LocalId;
		}

		/**
		 * Save all Customer Events
		 * @param {array} objList 
		 */
		function setCustomerEventsToStorage(objList) {
			GenericService.saveAll(objList, objType);
		}

		/**
		 * Add or Update a Customer Event
		 * @param {object} customerEvent 
		 */
		function setCustomerEventToStorage(customerEvent) {
			var flightCustomerEvents = getFlightCustomerEvents(customerEvent.FlightId, customerEvent.UCI);

			if (flightCustomerEvents) {
				var incident = flightCustomerEvents.find(x => x.LocalId == customerEvent.LocalId);

				if (incident) {
					updateCustomerEvent(customerEvent);
				}
				else {
					saveCustomerEvent(customerEvent);
				}
			}
			else {
				saveCustomerEvent(customerEvent);
			}
		}

		/**
		 * Get all passenger events of a flight
		 * @param {number} flightId 
		 */
		function getCustomerEventsByFlightId(flightId) {
			var allIncidents = getCustomerEventsFromStorage();
			var flightIncidents = allIncidents.filter(x => x.FlightId == flightId);
			return flightIncidents;
		};

		/**
		 * Group all customer events of a flight by passenger
		 * @param {number} flightId 
		 */
		function groupFlightCustomerEventsByPassenger(flightId) {
			var oneStopShopPassengers = [];
			var allIncidents = getCustomerEventsFromStorage();
			var flightIncidents = allIncidents.filter(x => x.FlightId == flightId);

			var oneStopShopPassengerIds = [...new Set(flightIncidents.map(x => x.UCI))];

			oneStopShopPassengerIds.forEach(function (id) {
				var incident = flightIncidents.find(x => x.UCI == id);
				var passenger = {
					UCI: incident.UCI,
					GivenName: incident.GivenName,
					Surname: incident.Surname,
					SeatNo: incident.SeatNo,
					OneStopShopEvents: []
				};

				flightIncidents.filter(x => x.UCI == id).forEach(function (incident) {
					var event = {
						ToolkitItemId: incident.ToolkitItemId,
						TreatmentId: incident.TreatmentId,
						NPS: incident.NPS,
						Synced: incident.Synced
					};
					passenger.OneStopShopEvents.push(event);
				});

				oneStopShopPassengers.push(passenger);
			});

			return oneStopShopPassengers;
		};

		/**
		 * Get all customer events
		 */
		function getCustomerEventsFromStorage() {
			return GenericService.list(objType, objCallback);
		}

		/**
		 * Get events for a specific passenger in a specific flight
		 * @param {number} flightId 
		 * @param {number} uci 
		 */
		function getFlightCustomerEvents(flightId, uci) {
			var flightIncidents = getCustomerEventsByFlightId(flightId);
			var customerEvents = flightIncidents.filter(x => x.UCI == uci);
			return customerEvents;
		}

		/**
		 * Update a customer event (Search by FlightId-ToolkitItemId-UCI)
		 * @param {object} customerEvent 
		 */
		function updateCustomerEvent(customerEvent) {
			GenericService.save(customerEvent, objType, objCallback);
		}

		/**
		 * Create a new customer event
		 * @param {object} customerEvent 
		 */
		function saveCustomerEvent(customerEvent) {
			GenericService.add(customerEvent, objType, objCallback);
		}

		/**
		 * Remove customer event from storage   
		 * @param {object} customerEvent 
		 */
		function removeCustomerEvent(customerEventId) {
			GenericService.remove(customerEventId, objType, objCallback);
		}

		/**
		 * Get Customers Events that have not yet been Synced
		 */
		function getUnsyncedCustomerEvents() {
			var unsyncedEvents = getCustomerEventsFromStorage().filter(x => !x.Synced);

			//Give each event a temporary Id
			var tempId = 1;
			unsyncedEvents.forEach(function (event) {
				event.TemporaryId = tempId;
				tempId++;

				//No Treatment Id needs to be sent as null
				if (event.TreatmentId == -1) {
					event.TreatmentId = null;
				}
			});

			return unsyncedEvents;
		}

		/**
		 * Deletes Customer Events that are older than 2 days
		 * @memberof DataCleanerFactory
		 */
		function deleteOldCustomerEvents() {
			var customerEvents = getCustomerEventsFromStorage();
			var fromDate = new Date();
			fromDate.setDate(fromDate.getDate() - 5);
			customerEvents = customerEvents.filter(x => x != null && x.FlightDate >= fromDate);
			setCustomerEventsToStorage(customerEvents);
		}

		return service;
	}
})();